import { createChildListModalContainer } from 'factories/ChildListModal'
import actions from 'actions/dashboardTemplates'
import Component from 'components/DashboardTemplates/FormView/Metrics/Select'

export default createChildListModalContainer({ actions })(Component)
